<div class="ordertable">

  <div class="heading">
    <div class="column column-image-and-description">{{ 'orders.product' | translate }}</div>
    <div class="column column-deliverydata text-right">{{ 'orders.delivered' | translate }}/{{ 'orders.open' | translate }} </div>
    <div class="column column-price text-right">{{ 'orders.price' | translate }}</div>
    <div class="column column-quantity text-right">{{ 'order.reorder' | translate }}</div>
    <!-- <div class="column column-orderbutton text-right">{{ 'orders.addtocart' | translate }}</div> -->
 </div>

  <div class="data">

    <app-orderline *ngFor="let order of orders"
                   [order]="order"
                   [cartProduct]="cartProduct(order)"
                   [currency]="currency"
                   (onAddCart)="addCart($event)">
    </app-orderline>

  </div>
</div>
